import { render } from "./TableSchema.vue?vue&type=template&id=1f0f9646&scoped=true"
import script from "./TableSchema.vue?vue&type=script&lang=js"
export * from "./TableSchema.vue?vue&type=script&lang=js"

import "./TableSchema.vue?vue&type=style&index=0&id=1f0f9646&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0f9646"]])

export default __exports__